/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetHealth200Response
 */
export interface GetHealth200Response {
    /**
     * 
     */
    status?: string;
    /**
     * 
     */
    version?: string;
}

/**
 * Check if a given object implements the GetHealth200Response interface.
 */
export function instanceOfGetHealth200Response(value: object): value is GetHealth200Response {
    return true;
}

export function GetHealth200ResponseFromJSON(json: any): GetHealth200Response {
    return GetHealth200ResponseFromJSONTyped(json, false);
}

export function GetHealth200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHealth200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function GetHealth200ResponseToJSON(json: any): GetHealth200Response {
    return GetHealth200ResponseToJSONTyped(json, false);
}

export function GetHealth200ResponseToJSONTyped(value?: GetHealth200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'version': value['version'],
    };
}

